import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const VideoModal = ({ youtubeId, title, onClose }) => {
  useEffect(() => {
    const handleKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  if (!youtubeId) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm px-4 animate-[fadeUp_0.3s_ease]"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-5xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-3">
          <span className="font-display text-white/80 text-sm tracking-widest uppercase">
            {title || 'Now Playing'}
          </span>
          <button
            onClick={onClose}
            aria-label="Close video"
            className="p-2 rounded-full bg-white/10 hover:bg-[#c9a85f] hover:text-black text-white transition-colors"
          >
            <X size={20} />
          </button>
        </div>
        <div className="relative w-full overflow-hidden rounded-xl border border-white/10 shadow-2xl" style={{ paddingTop: '56.25%' }}>
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${youtubeId}?rel=0&modestbranding=1`}
            title={title || 'Video player'}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
